/**
 * Web API
 * API Version 1.0.1
 */
import mixin  from '../mixin.js';
export class ApiConfig {
    constructor (basepath = "http://api.mangahot.jp/koreyomo/v1", headers = {}) {
        /**
         * Endpoint
         * @type {string}
         */
        this.basepath = basepath;

        /**
         * Additional header.
         * @type {Object}
         */
        this.headers = headers;
    }
}


export class KoreyomoApi {
    /**
     * @param {?ApiConfig} config Configuration object.
     * @constructor
     */
    constructor (config) {
        if (config === void 0) { config = new ApiConfig(); }
        this._config = config;
    }



    /**
     * Result of feedbacksClickPost callback function
     *
     * @callback feedbacksClickPostCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoFeedbackResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Send feedback of selected works to MAI.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @param { string } timeRes Time returned from recommend API results.
     * @param { number } personaId This value is used by MAI.
     * @param { ?string } userId A unique identifier for this User.
     * @param { feedbacksClickPostCallback } callback Callback function
     */
    feedbacksClickPost (workCode, timeRes, personaId, rt, userId) {
        if (workCode === void 0) { workCode = null; }
        if (timeRes === void 0) { timeRes = null; }
        if (personaId === void 0) { personaId = null; }
        if (userId === void 0) { userId = null; }

        var url = this._config.basepath + "/feedbacks/click";

        var query = {
            "workCode": workCode,
            "timeRes": timeRes,
            "personaId": personaId,
            "userId": userId
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "post",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            if ($cookies.isKey('userId')) {
                $cookies.remove('userId');
            }
            $cookies.set('userId', data.userId, '10MIN');
            //resolve(data);
            //callback(null, data, response);
           
        }).then(function(){
            let query = ""
            if (rt !== null) {
              query += "&rt=" + rt
            }
            if (timeRes !== null) {
              query += "&timeres=" + timeRes
            }
            if (personaId !== null) {
              query += "&pid=" + personaId
            }
            if (query.length > 0) {
              query = "?" + query.slice(1);
            }

            let url = process.env.DETAIL_URL
            if (url.charAt(0) === "/") {
              query += query.length > 0 ? "&" : "?"
              query += "workcode=" + workCode
              url = url + "/" + query
            } else {
              // Staging or Production server.
              url = url + "/" + workCode + query
            }
            window.location.href = url;
        }).catch(function (error) {
            //callback(error, null, null);
        });
    }

    /**
     * Send feedback of selected works to MAI.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @param { string } timeRes Time returned from recommend API results.
     * @param { number } personaId This value is used by MAI.
     * @param { ?string } userId A unique identifier for this User.
     * @returns { Promise.<KoreyomoFeedbackResult> }
     */
    async feedbacksClickPostAsync(workCode, timeRes, personaId, userId) {
        return new Promise((resolve, reject) => {
            this.feedbacksClickPost(workCode, timeRes, personaId, userId, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of feedbacksReadProgressPost callback function
     *
     * @callback feedbacksReadProgressPostCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoFeedbackResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Send feedback of reading works to MAI.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @param { number } storyId A unique identifier for the story.
     * @param { number } readPages The number of reading pages. The minimum value is 1.
     * @param { number } totalPages The number of pages.
     * @param { string } timeRes Time returned from recommend API results.
     * @param { number } personaId This value is used by MAI.
     * @param { ?string } userId A unique identifier for user.
     * @param { feedbacksReadProgressPostCallback } callback Callback function
     */
    feedbacksReadProgressPost (workCode, storyId, readPages, totalPages, timeRes, personaId, userId, callback) {
        if (workCode === void 0) { workCode = null; }
        if (storyId === void 0) { storyId = null; }
        if (readPages === void 0) { readPages = null; }
        if (totalPages === void 0) { totalPages = null; }
        if (timeRes === void 0) { timeRes = null; }
        if (personaId === void 0) { personaId = null; }
        if (userId === void 0) { userId = null; }

        var url = this._config.basepath + "/feedbacks/readProgress";

        var query = {
            "workCode": workCode,
            "storyId": storyId,
            "readPages": readPages,
            "totalPages": totalPages,
            "timeRes": timeRes,
            "personaId": personaId,
            "userId": userId
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "post",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Send feedback of reading works to MAI.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @param { number } storyId A unique identifier for the story.
     * @param { number } readPages The number of reading pages. The minimum value is 1.
     * @param { number } totalPages The number of pages.
     * @param { string } timeRes Time returned from recommend API results.
     * @param { number } personaId This value is used by MAI.
     * @param { ?string } userId A unique identifier for user.
     * @returns { Promise.<KoreyomoFeedbackResult> }
     */
    async feedbacksReadProgressPostAsync(workCode, storyId, readPages, totalPages, timeRes, personaId, userId) {
        return new Promise((resolve, reject) => {
            this.feedbacksReadProgressPost(workCode, storyId, readPages, totalPages, timeRes, personaId, userId, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of mAIImagesGet callback function
     *
     * @callback mAIImagesGetCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoMAIImageResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Get image resources related to MAI.
     * @param { boolean } smartphone Request images for smartphones.
     * @param { mAIImagesGetCallback } callback Callback function
     */
    mAIImagesGet (smartphone, callback) {
        if (smartphone === void 0) { smartphone = null; }

        var url = this._config.basepath + "/MAIImages";

        var query = {
            "smartphone": smartphone
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "get",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Get image resources related to MAI.
     * @param { boolean } smartphone Request images for smartphones.
     * @returns { Promise.<KoreyomoMAIImageResult> }
     */
    async mAIImagesGetAsync(smartphone) {
        return new Promise((resolve, reject) => {
            this.mAIImagesGet(smartphone, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of worksRecommendWorksFromParametersGet callback function
     *
     * @callback worksRecommendWorksFromParametersGetCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoWorkResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Get recommended results from selected parameters.
     * @param { string } topWorkCode Work code of 1st rank.
     * @param { number } personaId This value is used by MAI.
     * @param { number } param1 1st parameter.
     * @param { number } param2 2nd parameter.
     * @param { number } param3 3rd parameter.
     * @param { number } param4 4th parameter.
     * @param { number } param5 5th parameter.
     * @param { number } param6 6th parameter.
     * @param { number } param7 7th parameter.
     * @param { number } param8 8th parameter.
     * @param { number } param9 9th parameter.
     * @param { number } param10 10th parameter.
     * @param { ?string } userId A unique identifier for this User.
     * @param { worksRecommendWorksFromParametersGetCallback } callback Callback function
     */
    worksRecommendWorksFromParametersGet (topWorkCode, personaId, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, userId, callback) {
        if (topWorkCode === void 0) { topWorkCode = null; }
        if (personaId === void 0) { personaId = null; }
        if (param1 === void 0) { param1 = null; }
        if (param2 === void 0) { param2 = null; }
        if (param3 === void 0) { param3 = null; }
        if (param4 === void 0) { param4 = null; }
        if (param5 === void 0) { param5 = null; }
        if (param6 === void 0) { param6 = null; }
        if (param7 === void 0) { param7 = null; }
        if (param8 === void 0) { param8 = null; }
        if (param9 === void 0) { param9 = null; }
        if (param10 === void 0) { param10 = null; }
        if (userId === void 0) { userId = null; }

        var url = this._config.basepath + "/works/recommendWorksFromParameters";

        var query = {
            "topWorkCode": topWorkCode,
            "personaId": personaId,
            "param1": param1,
            "param2": param2,
            "param3": param3,
            "param4": param4,
            "param5": param5,
            "param6": param6,
            "param7": param7,
            "param8": param8,
            "param9": param9,
            "param10": param10,
            "userId": userId
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "get",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Get recommended results from selected parameters.
     * @param { string } topWorkCode Work code of 1st rank.
     * @param { number } personaId This value is used by MAI.
     * @param { number } param1 1st parameter.
     * @param { number } param2 2nd parameter.
     * @param { number } param3 3rd parameter.
     * @param { number } param4 4th parameter.
     * @param { number } param5 5th parameter.
     * @param { number } param6 6th parameter.
     * @param { number } param7 7th parameter.
     * @param { number } param8 8th parameter.
     * @param { number } param9 9th parameter.
     * @param { number } param10 10th parameter.
     * @param { ?string } userId A unique identifier for this User.
     * @returns { Promise.<KoreyomoWorkResult> }
     */
    async worksRecommendWorksFromParametersGetAsync(topWorkCode, personaId, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, userId) {
        return new Promise((resolve, reject) => {
            this.worksRecommendWorksFromParametersGet(topWorkCode, personaId, param1, param2, param3, param4, param5, param6, param7, param8, param9, param10, userId, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of worksRecommendWorksFromTokenGet callback function
     *
     * @callback worksRecommendWorksFromTokenGetCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoWorkResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Get recommended results from restore token.
     * @param { string } token Restore token.
     * @param { worksRecommendWorksFromTokenGetCallback } callback Callback function
     */
    worksRecommendWorksFromTokenGet (token, callback) {
        if (token === void 0) { token = null; }

        var url = this._config.basepath + "/works/recommendWorksFromToken";

        var query = {
            "token": token
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "get",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Get recommended results from restore token.
     * @param { string } token Restore token.
     * @returns { Promise.<KoreyomoWorkResult> }
     */
    async worksRecommendWorksFromTokenGetAsync(token) {
        return new Promise((resolve, reject) => {
            this.worksRecommendWorksFromTokenGet(token, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of worksRecommendWorksFromWorksGet callback function
     *
     * @callback worksRecommendWorksFromWorksGetCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoWorkResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Get recommended results from selected works.
     * @param { string } workCodes Array of WorkCode. The value is comma separated.
     * @param { worksRecommendWorksFromWorksGetCallback } callback Callback function
     */
    worksRecommendWorksFromWorksGet (workCodes, callback) {
        if (workCodes === void 0) { workCodes = null; }

        var url = this._config.basepath + "/works/recommendWorksFromWorks";

        var query = {
            "workCodes": workCodes
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "get",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Get recommended results from selected works.
     * @param { string } workCodes Array of WorkCode. The value is comma separated.
     * @returns { Promise.<KoreyomoWorkResult> }
     */
    async worksRecommendWorksFromWorksGetAsync(workCodes) {
        return new Promise((resolve, reject) => {
            this.worksRecommendWorksFromWorksGet(workCodes, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of worksStoriesWorkCodeGet callback function
     *
     * @callback worksStoriesWorkCodeGetCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoStoryListResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Get a list of stories.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @param { worksStoriesWorkCodeGetCallback } callback Callback function
     */
    worksStoriesWorkCodeGet (workCode, callback) {
        if (workCode === void 0) { workCode = null; }

        var url = this._config.basepath + "/works/stories/{workCode}"
                .replace('{' + 'workCode' + '}', encodeURIComponent(String(workCode)));

        var query = {
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "get",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Get a list of stories.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @returns { Promise.<KoreyomoStoryListResult> }
     */
    async worksStoriesWorkCodeGetAsync(workCode) {
        return new Promise((resolve, reject) => {
            this.worksStoriesWorkCodeGet(workCode, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of worksStoryDetailWorkCodeStoryIdGet callback function
     *
     * @callback worksStoryDetailWorkCodeStoryIdGetCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoStoryResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Get the details of the story.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @param { number } storyId A unique identifier for the story.
     * @param { worksStoryDetailWorkCodeStoryIdGetCallback } callback Callback function
     */
    worksStoryDetailWorkCodeStoryIdGet (workCode, storyId, callback) {
        if (workCode === void 0) { workCode = null; }
        if (storyId === void 0) { storyId = null; }

        var url = this._config.basepath + "/works/storyDetail/{workCode}/{storyId}"
                .replace('{' + 'workCode' + '}', encodeURIComponent(String(workCode)))
                .replace('{' + 'storyId' + '}', encodeURIComponent(String(storyId)));

        var query = {
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "get",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Get the details of the story.
     * @param { string } workCode A unique code for the publisher to identify the work.
     * @param { number } storyId A unique identifier for the story.
     * @returns { Promise.<KoreyomoStoryResult> }
     */
    async worksStoryDetailWorkCodeStoryIdGetAsync(workCode, storyId) {
        return new Promise((resolve, reject) => {
            this.worksStoryDetailWorkCodeStoryIdGet(workCode, storyId, (error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }



    /**
     * Result of worksThumbnailListGet callback function
     *
     * @callback worksThumbnailListGetCallback
     * @param { ?Object } error Error object
     * @param { ?KoreyomoThumbnailResult } data Data object
     * @param { Object } response Response information
     */

    /**
     * Get a thumbnail list of works.
     * @param { worksThumbnailListGetCallback } callback Callback function
     */
    worksThumbnailListGet (callback) {

        var url = this._config.basepath + "/works/thumbnailList";

        var query = {
        };
        var request_data = {};

        var headers = {
            "Content-Type": "application/json"
        };
        var request_headers = mergeObject(this._config.headers, headers);

        axios({
            url: url,
            method: "get",
            params: query,
            data: request_data,
            headers: request_headers
        }).then(function (response) {
            var data = response.data;
            callback(null, data, response);
        }).catch(function (error) {
            callback(error, null, null);
        });
    }

    /**
     * Get a thumbnail list of works.
     * @returns { Promise.<KoreyomoThumbnailResult> }
     */
    async worksThumbnailListGetAsync() {
        return new Promise((resolve, reject) => {
            this.worksThumbnailListGet((error, data, response) => {
                if (error !== null) {
                    reject(error);
                    return;
                }
                resolve(data);
            });
        });
    }


}


/**
 * Error object
 * @constructor
 */
export class Error {
    constructor() {
        /**
         * @type { number } Error code. * 0: Success. * -1: Unknown error. * -2: Invalid argument. * -3: Invalid URL request. * -8001: There is no corresponding work. * -8002: Restore token is invalid. * -8003: Invalid number of pages. * -8004: The corresponding story cannot be browsed. * -8005: The corresponding story cannot be browsed on the Web. * -8006: The data of the corresponding story does not exist. * -8007: Failed to communicate with the MAI server. TBD Others 
         */
        this.code = null;
        /**
         * @type { string } Returns an error message. Use this message for debugging purposes. It should not be displayed as an error message. 
         */
        this.message = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { Error }
     */
    static createFromJson (jsonObject) {
        const obj = new Error();
        if (typeof(jsonObject.code) !== "undefined") {
            obj.code = jsonObject.code;
        }
        if (typeof(jsonObject.message) !== "undefined") {
            obj.message = jsonObject.message;
        }
        return obj;
  }
}

/*
var request_data = new Error()
request_data.code = null;
request_data.message = null;
*/

/**
 * Result of sending feedback.
 * @constructor
 */
export class KoreyomoFeedbackResult {
    constructor() {
        /**
         * @type { string } A unique identifier for this User. The userId that sent the feedback. If userId is sent in empty, it will be newly created. 
         */
        this.userId = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoFeedbackResult }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoFeedbackResult();
        if (typeof(jsonObject.userId) !== "undefined") {
            obj.userId = jsonObject.userId;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoFeedbackResult()
request_data.userId = null;
*/

/**
 * Related images to MAI.
 * @constructor
 */
export class KoreyomoMAIImageResult {
    constructor() {
        /**
         * @type { Array.<string> } List of images for the top page.
         */
        this.topImages = null;
        /**
         * @type { string } An balloon image for the top page.  If an image is not selected, use this. 
         */
        this.topBalloonImage0 = null;
        /**
         * @type { string } A balloon image for the top page.  If an image is selected, use this. 
         */
        this.topBalloonImage1 = null;
        /**
         * @type { string } A balloon image for the top page.  If two images are selected, use this. 
         */
        this.topBalloonImage2 = null;
        /**
         * @type { string } A balloon image for the top page.  If three images or higher are selected, use this. 
         */
        this.topBalloonImage3 = null;
        /**
         * @type { Array.<string> } List of balloon images. 
         */
        this.balloonImages = null;
        /**
         * @type { string } A balloon image for the SNS sharing page.  If three images or higher are selected, use this. 
         */
        this.diagnosisBalloonImages = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoMAIImageResult }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoMAIImageResult();
        if (typeof(jsonObject.topImages) !== "undefined") {
            if (jsonObject.topImages !== null) {
                obj.topImages = [];
                for (let i = 0; i < jsonObject.topImages.length; i++) {
                    const item = jsonObject.topImages[i];
                    obj.topImages.push(item);
                }
            } else {
                obj.topImages = null;
            }
        }
        if (typeof(jsonObject.topBalloonImage0) !== "undefined") {
            obj.topBalloonImage0 = jsonObject.topBalloonImage0;
        }
        if (typeof(jsonObject.topBalloonImage1) !== "undefined") {
            obj.topBalloonImage1 = jsonObject.topBalloonImage1;
        }
        if (typeof(jsonObject.topBalloonImage2) !== "undefined") {
            obj.topBalloonImage2 = jsonObject.topBalloonImage2;
        }
        if (typeof(jsonObject.topBalloonImage3) !== "undefined") {
            obj.topBalloonImage3 = jsonObject.topBalloonImage3;
        }
        if (typeof(jsonObject.balloonImages) !== "undefined") {
            if (jsonObject.balloonImages !== null) {
                obj.balloonImages = [];
                for (let i = 0; i < jsonObject.balloonImages.length; i++) {
                    const item = jsonObject.balloonImages[i];
                    obj.balloonImages.push(item);
                }
            } else {
                obj.balloonImages = null;
            }
        }
        if (typeof(jsonObject.diagnosisBalloonImages) !== "undefined") {
            obj.diagnosisBalloonImages = jsonObject.diagnosisBalloonImages;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoMAIImageResult()
request_data.topImages = null;
request_data.topBalloonImage0 = null;
request_data.topBalloonImage1 = null;
request_data.topBalloonImage2 = null;
request_data.topBalloonImage3 = null;
request_data.balloonImages = null;
request_data.diagnosisBalloonImages = null;
*/

/**
 * The information returned from MAI.
 * @constructor
 */
export class KoreyomoMAIResult {
    constructor() {
        /**
         * @type { number } This value is used by MAI.
         */
        this.personaId = null;
        /**
         * @type { string } Trend analysis catchphrase.
         */
        this.personaText = null;
        /**
         * @type { string } Time when MAI returned an API response. Used to send feedback to the MAI. 
         */
        this.timeRes = null;
        /**
         * @type { number } 1st slider parameter.
         */
        this.param1 = null;
        /**
         * @type { number } 2nd slider parameter.
         */
        this.param2 = null;
        /**
         * @type { number } 3rd slider parameter.
         */
        this.param3 = null;
        /**
         * @type { number } 4th slider parameter.
         */
        this.param4 = null;
        /**
         * @type { number } 5th slider parameter.
         */
        this.param5 = null;
        /**
         * @type { number } 6th slider parameter.
         */
        this.param6 = null;
        /**
         * @type { number } 7th slider parameter.
         */
        this.param7 = null;
        /**
         * @type { number } 8th slider parameter.
         */
        this.param8 = null;
        /**
         * @type { number } 9th slider parameter.
         */
        this.param9 = null;
        /**
         * @type { number } 10th slider parameter.
         */
        this.param10 = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoMAIResult }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoMAIResult();
        if (typeof(jsonObject.personaId) !== "undefined") {
            obj.personaId = jsonObject.personaId;
        }
        if (typeof(jsonObject.personaText) !== "undefined") {
            obj.personaText = jsonObject.personaText;
        }
        if (typeof(jsonObject.timeRes) !== "undefined") {
            obj.timeRes = jsonObject.timeRes;
        }
        if (typeof(jsonObject.param1) !== "undefined") {
            obj.param1 = jsonObject.param1;
        }
        if (typeof(jsonObject.param2) !== "undefined") {
            obj.param2 = jsonObject.param2;
        }
        if (typeof(jsonObject.param3) !== "undefined") {
            obj.param3 = jsonObject.param3;
        }
        if (typeof(jsonObject.param4) !== "undefined") {
            obj.param4 = jsonObject.param4;
        }
        if (typeof(jsonObject.param5) !== "undefined") {
            obj.param5 = jsonObject.param5;
        }
        if (typeof(jsonObject.param6) !== "undefined") {
            obj.param6 = jsonObject.param6;
        }
        if (typeof(jsonObject.param7) !== "undefined") {
            obj.param7 = jsonObject.param7;
        }
        if (typeof(jsonObject.param8) !== "undefined") {
            obj.param8 = jsonObject.param8;
        }
        if (typeof(jsonObject.param9) !== "undefined") {
            obj.param9 = jsonObject.param9;
        }
        if (typeof(jsonObject.param10) !== "undefined") {
            obj.param10 = jsonObject.param10;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoMAIResult()
request_data.personaId = null;
request_data.personaText = null;
request_data.timeRes = null;
request_data.param1 = null;
request_data.param2 = null;
request_data.param3 = null;
request_data.param4 = null;
request_data.param5 = null;
request_data.param6 = null;
request_data.param7 = null;
request_data.param8 = null;
request_data.param9 = null;
request_data.param10 = null;
*/

/**
 * Image URL information of each page.
 * @constructor
 */
export class KoreyomoStoryContent {
    constructor() {
        /**
         * @type { number } A unique identifier for work.
         */
        this.storyId = null;
        /**
         * @type { Array.<string> } Array of content URLs
         */
        this.contentUrls = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoStoryContent }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoStoryContent();
        if (typeof(jsonObject.storyId) !== "undefined") {
            obj.storyId = jsonObject.storyId;
        }
        if (typeof(jsonObject.contentUrls) !== "undefined") {
            if (jsonObject.contentUrls !== null) {
                obj.contentUrls = [];
                for (let i = 0; i < jsonObject.contentUrls.length; i++) {
                    const item = jsonObject.contentUrls[i];
                    obj.contentUrls.push(item);
                }
            } else {
                obj.contentUrls = null;
            }
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoStoryContent()
request_data.storyId = null;
request_data.contentUrls = null;
*/

/**
 * Story information.
 * @constructor
 */
export class KoreyomoStoryItem {
    constructor() {
        /**
         * @type { number } A unique identifier for the story.
         */
        this.storyId = null;
        /**
         * @type { string } An image URL of story banner.
         */
        this.storyBannerImageUrl = null;
        /**
         * @type { number } The number of stories.
         */
        this.storyNumber = null;
        /**
         * @type { string } Title of the story.
         */
        this.storyTitle = null;
        /**
         * @type { string } Comment of the story.
         */
        this.storyComment = null;
        /**
         * @type { boolean } Free flag.
         */
        this.isFree = null;
        /**
         * @type { boolean } Flag of the draft comic.
         */
        this.isName = null;
        /**
         * @type { boolean } Tickets are required for viewing.
         */
        this.isTicket = null;
        /**
         * @type { boolean } Look ahead flag.
         */
        this.lookahead = null;
        /**
         * @type { Date } Start date and time of the story.
         */
        this.storyStartedAt = null;
        /**
         * @type { Date } End date and time of the story.
         */
        this.storyEndedAt = null;
        /**
         * @type { ?boolean } Have already read a story.
         */
        this.storyReadFlag = null;
        /**
         * @type { boolean } Can reading from the koreyomo.
         */
        this.isWebRead = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoStoryItem }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoStoryItem();
        if (typeof(jsonObject.storyId) !== "undefined") {
            obj.storyId = jsonObject.storyId;
        }
        if (typeof(jsonObject.storyBannerImageUrl) !== "undefined") {
            obj.storyBannerImageUrl = jsonObject.storyBannerImageUrl;
        }
        if (typeof(jsonObject.storyNumber) !== "undefined") {
            obj.storyNumber = jsonObject.storyNumber;
        }
        if (typeof(jsonObject.storyTitle) !== "undefined") {
            obj.storyTitle = jsonObject.storyTitle;
        }
        if (typeof(jsonObject.storyComment) !== "undefined") {
            obj.storyComment = jsonObject.storyComment;
        }
        if (typeof(jsonObject.isFree) !== "undefined") {
            obj.isFree = jsonObject.isFree;
        }
        if (typeof(jsonObject.isName) !== "undefined") {
            obj.isName = jsonObject.isName;
        }
        if (typeof(jsonObject.isTicket) !== "undefined") {
            obj.isTicket = jsonObject.isTicket;
        }
        if (typeof(jsonObject.lookahead) !== "undefined") {
            obj.lookahead = jsonObject.lookahead;
        }
        if (typeof(jsonObject.storyStartedAt) !== "undefined") {
            obj.storyStartedAt = jsonObject.storyStartedAt;
        }
        if (typeof(jsonObject.storyEndedAt) !== "undefined") {
            obj.storyEndedAt = jsonObject.storyEndedAt;
        }
        if (typeof(jsonObject.storyReadFlag) !== "undefined") {
            obj.storyReadFlag = jsonObject.storyReadFlag;
        }
        if (typeof(jsonObject.isWebRead) !== "undefined") {
            obj.isWebRead = jsonObject.isWebRead;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoStoryItem()
request_data.storyId = null;
request_data.storyBannerImageUrl = null;
request_data.storyNumber = null;
request_data.storyTitle = null;
request_data.storyComment = null;
request_data.isFree = null;
request_data.isName = null;
request_data.isTicket = null;
request_data.lookahead = null;
request_data.storyStartedAt = null;
request_data.storyEndedAt = null;
request_data.storyReadFlag = null;
request_data.isWebRead = null;
*/

/**
 * Result list of stories.
 * @constructor
 */
export class KoreyomoStoryListResult {
    constructor() {
        /**
         * @type { KoreyomoWorkInfo } 
         */
        this.workInfo = null;
        /**
         * @type { Array.<KoreyomoStoryItem> } 
         */
        this.storyItemList = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoStoryListResult }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoStoryListResult();
        if (typeof(jsonObject.workInfo) !== "undefined") {
            obj.workInfo = jsonObject.workInfo;
        }
        if (typeof(jsonObject.storyItemList) !== "undefined") {
            if (jsonObject.storyItemList !== null) {
                obj.storyItemList = [];
                for (let i = 0; i < jsonObject.storyItemList.length; i++) {
                    const item = KoreyomoStoryItem.createFromJson(jsonObject.storyItemList[i]);
                    obj.storyItemList.push(item);
                }
            } else {
                obj.storyItemList = null;
            }
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoStoryListResult()
request_data.workInfo = null;
request_data.storyItemList = null;
*/

/**
 * List of stories. If there is no next story, `nextStoryItem` is null. 
 * @constructor
 */
export class KoreyomoStoryResult {
    constructor() {
        /**
         * @type { KoreyomoStoryContent } 
         */
        this.content = null;
        /**
         * @type { KoreyomoWorkInfo } 
         */
        this.workInfo = null;
        /**
         * @type { KoreyomoStoryItem } 
         */
        this.storyItem = null;
        /**
         * @type { ?KoreyomoStoryItem } 
         */
        this.nextStoryItem = null;
        /**
         * @type { Array.<KoreyomoWorkItem> } 
         */
        this.recommendWorks = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoStoryResult }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoStoryResult();
        if (typeof(jsonObject.content) !== "undefined") {
            obj.content = jsonObject.content;
        }
        if (typeof(jsonObject.workInfo) !== "undefined") {
            obj.workInfo = jsonObject.workInfo;
        }
        if (typeof(jsonObject.storyItem) !== "undefined") {
            obj.storyItem = jsonObject.storyItem;
        }
        if (typeof(jsonObject.nextStoryItem) !== "undefined") {
            obj.nextStoryItem = jsonObject.nextStoryItem;
        }
        if (typeof(jsonObject.recommendWorks) !== "undefined") {
            if (jsonObject.recommendWorks !== null) {
                obj.recommendWorks = [];
                for (let i = 0; i < jsonObject.recommendWorks.length; i++) {
                    const item = KoreyomoWorkItem.createFromJson(jsonObject.recommendWorks[i]);
                    obj.recommendWorks.push(item);
                }
            } else {
                obj.recommendWorks = null;
            }
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoStoryResult()
request_data.content = null;
request_data.workInfo = null;
request_data.storyItem = null;
request_data.nextStoryItem = null;
request_data.recommendWorks = null;
*/

/**
 * Thumbnail information of the work.
 * @constructor
 */
export class KoreyomoThumbnailItem {
    constructor() {
        /**
         * @type { number } A unique identifier for work.
         */
        this.workId = null;
        /**
         * @type { string } A unique code for the publisher to identify the work.
         */
        this.workCode = null;
        /**
         * @type { string } The name of the work.
         */
        this.workName = null;
        /**
         * @type { string } Small banner Image URL.
         */
        this.bannerSmallImageUrl = null;
        /**
         * @type { string } Monochrome banner Image URL.
         */
        this.bannerMonochromeImageUrl = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoThumbnailItem }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoThumbnailItem();
        if (typeof(jsonObject.workId) !== "undefined") {
            obj.workId = jsonObject.workId;
        }
        if (typeof(jsonObject.workCode) !== "undefined") {
            obj.workCode = jsonObject.workCode;
        }
        if (typeof(jsonObject.workName) !== "undefined") {
            obj.workName = jsonObject.workName;
        }
        if (typeof(jsonObject.bannerSmallImageUrl) !== "undefined") {
            obj.bannerSmallImageUrl = jsonObject.bannerSmallImageUrl;
        }
        if (typeof(jsonObject.bannerMonochromeImageUrl) !== "undefined") {
            obj.bannerMonochromeImageUrl = jsonObject.bannerMonochromeImageUrl;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoThumbnailItem()
request_data.workId = null;
request_data.workCode = null;
request_data.workName = null;
request_data.bannerSmallImageUrl = null;
request_data.bannerMonochromeImageUrl = null;
*/

/**
 * Thumbnail list of the work.
 * @constructor
 */
export class KoreyomoThumbnailResult {
    constructor() {
        /**
         * @type { Array.<KoreyomoThumbnailItem> } 
         */
        this.thumbnailList = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoThumbnailResult }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoThumbnailResult();
        if (typeof(jsonObject.thumbnailList) !== "undefined") {
            if (jsonObject.thumbnailList !== null) {
                obj.thumbnailList = [];
                for (let i = 0; i < jsonObject.thumbnailList.length; i++) {
                    const item = KoreyomoThumbnailItem.createFromJson(jsonObject.thumbnailList[i]);
                    obj.thumbnailList.push(item);
                }
            } else {
                obj.thumbnailList = null;
            }
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoThumbnailResult()
request_data.thumbnailList = null;
*/

/**
 * The work information of the first place that MAI returned.
 * @constructor
 */
export class KoreyomoTopWorkItem {
    constructor() {
        /**
         * @type { number } A unique identifier for work.
         */
        this.workId = null;
        /**
         * @type { string } A unique code for the publisher to identify the work.
         */
        this.workCode = null;
        /**
         * @type { string } The name of the work.
         */
        this.workName = null;
        /**
         * @type { string } Large banner Image URL.
         */
        this.bannerLargeImageUrl = null;
        /**
         * @type { string } Medium banner Image URL.
         */
        this.bannerMediumImageUrl = null;
        /**
         * @type { string } Small banner Image URL.
         */
        this.bannerSmallImageUrl = null;
        /**
         * @type { string } Monochrome banner Image URL.
         */
        this.bannerMonochromeImageUrl = null;
        /**
         * @type { string } The background color of the work.
         */
        this.backgroundColor = null;
        /**
         * @type { string } Already read the color of the work.
         */
        this.visitedColor = null;
        /**
         * @type { string } Text color of the work.
         */
        this.textColor = null;
        /**
         * @type { string } Button color of the work.
         */
        this.buttonColor = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoTopWorkItem }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoTopWorkItem();
        if (typeof(jsonObject.workId) !== "undefined") {
            obj.workId = jsonObject.workId;
        }
        if (typeof(jsonObject.workCode) !== "undefined") {
            obj.workCode = jsonObject.workCode;
        }
        if (typeof(jsonObject.workName) !== "undefined") {
            obj.workName = jsonObject.workName;
        }
        if (typeof(jsonObject.bannerLargeImageUrl) !== "undefined") {
            obj.bannerLargeImageUrl = jsonObject.bannerLargeImageUrl;
        }
        if (typeof(jsonObject.bannerMediumImageUrl) !== "undefined") {
            obj.bannerMediumImageUrl = jsonObject.bannerMediumImageUrl;
        }
        if (typeof(jsonObject.bannerSmallImageUrl) !== "undefined") {
            obj.bannerSmallImageUrl = jsonObject.bannerSmallImageUrl;
        }
        if (typeof(jsonObject.bannerMonochromeImageUrl) !== "undefined") {
            obj.bannerMonochromeImageUrl = jsonObject.bannerMonochromeImageUrl;
        }
        if (typeof(jsonObject.backgroundColor) !== "undefined") {
            obj.backgroundColor = jsonObject.backgroundColor;
        }
        if (typeof(jsonObject.visitedColor) !== "undefined") {
            obj.visitedColor = jsonObject.visitedColor;
        }
        if (typeof(jsonObject.textColor) !== "undefined") {
            obj.textColor = jsonObject.textColor;
        }
        if (typeof(jsonObject.buttonColor) !== "undefined") {
            obj.buttonColor = jsonObject.buttonColor;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoTopWorkItem()
request_data.workId = null;
request_data.workCode = null;
request_data.workName = null;
request_data.bannerLargeImageUrl = null;
request_data.bannerMediumImageUrl = null;
request_data.bannerSmallImageUrl = null;
request_data.bannerMonochromeImageUrl = null;
request_data.backgroundColor = null;
request_data.visitedColor = null;
request_data.textColor = null;
request_data.buttonColor = null;
*/

/**
 * Work information
 * @constructor
 */
export class KoreyomoWorkInfo {
    constructor() {
        /**
         * @type { number } A unique identifier for work.
         */
        this.workId = null;
        /**
         * @type { string } A unique code for the publisher to identify the work.
         */
        this.workCode = null;
        /**
         * @type { string } The name of the work.
         */
        this.workName = null;
        /**
         * @type { string } The kana name of the work.
         */
        this.workNameKana = null;
        /**
         * @type { string } Name of the author.
         */
        this.authorName = null;
        /**
         * @type { ?string } Thumbnail URL of the author.
         */
        this.authorThumbnailUrl = null;
        /**
         * @type { string } Catchphrase of work.
         */
        this.catchPhrase = null;
        /**
         * @type { number } Kind of work type. * 1: Series * 2: All 
         */
        this.workKind = null;
        /**
         * @type { boolean } Flag of original work.
         */
        this.isOriginal = null;
        /**
         * @type { string } Large banner Image URL.
         */
        this.bannerLargeImageUrl = null;
        /**
         * @type { string } Medium banner Image URL.
         */
        this.bannerMediumImageUrl = null;
        /**
         * @type { string } Small banner Image URL.
         */
        this.bannerSmallImageUrl = null;
        /**
         * @type { number } Kind of comment icon. * 1: White icon. * 2: Black icon. 
         */
        this.commentIconKind = null;
        /**
         * @type { string } The background color of the work.
         */
        this.backgroundColor = null;
        /**
         * @type { string } Already read the color of the work.
         */
        this.visitedColor = null;
        /**
         * @type { string } Text color of the work.
         */
        this.textColor = null;
        /**
         * @type { string } Button color of the work.
         */
        this.buttonColor = null;
        /**
         * @type { string } An outline of the work and notices.
         */
        this.description = null;
        /**
         * @type { Array.<number> } An array of genre identifier.
         */
        this.workGenres = null;
        /**
         * @type { Date } Start date and time of the work.
         */
        this.workStartedAt = null;
        /**
         * @type { Date } End date and time of the work.
         */
        this.workEndedAt = null;
        /**
         * @type { ?number } Kind of day of the week to be updated.   * 0: Unspecified   * 1: Sunday   * 2: Monday   * 3: Tuesday   * 4: Wednesday   * 5: Thursday   * 6: Friday   * 7: Saturday   * 8: Everyday 
         */
        this.updateDayKind = null;
        /**
         * @type { ?string } Update frequency.
         */
        this.updateIntervalName = null;
        /**
         * @type { ?number } The Number of stories on the newest story.
         */
        this.newestStoryNumber = null;
        /**
         * @type { ?string } Title of the newest story.
         */
        this.newestStoryTitle = null;
        /**
         * @type { boolean } Update flag.
         */
        this.isUpdated = null;
        /**
         * @type { boolean } Flag of the ended work.
         */
        this.hasEnded = null;
        /**
         * @type { string } URL link for sharing.
         */
        this.shareUrl = null;
        /**
         * @type { number } People category.   * 1: For Women   * 2: For men 
         */
        this.personCategory = null;
        /**
         * @type { number } Number of cheering works.
         */
        this.numberOfCheers = null;
        /**
         * @type { number } Number of favorites.
         */
        this.numberOfFavorites = null;
        /**
         * @type { boolean } Flag of my favorite.
         */
        this.isFavorite = null;
        /**
         * @type { boolean } Cheered for the work.
         */
        this.isCheered = null;
        /**
         * @type { ?string } An image URL of additional cheers.
         */
        this.addCheerImageUrl = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoWorkInfo }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoWorkInfo();
        if (typeof(jsonObject.workId) !== "undefined") {
            obj.workId = jsonObject.workId;
        }
        if (typeof(jsonObject.workCode) !== "undefined") {
            obj.workCode = jsonObject.workCode;
        }
        if (typeof(jsonObject.workName) !== "undefined") {
            obj.workName = jsonObject.workName;
        }
        if (typeof(jsonObject.workNameKana) !== "undefined") {
            obj.workNameKana = jsonObject.workNameKana;
        }
        if (typeof(jsonObject.authorName) !== "undefined") {
            obj.authorName = jsonObject.authorName;
        }
        if (typeof(jsonObject.authorThumbnailUrl) !== "undefined") {
            obj.authorThumbnailUrl = jsonObject.authorThumbnailUrl;
        }
        if (typeof(jsonObject.catchPhrase) !== "undefined") {
            obj.catchPhrase = jsonObject.catchPhrase;
        }
        if (typeof(jsonObject.workKind) !== "undefined") {
            obj.workKind = jsonObject.workKind;
        }
        if (typeof(jsonObject.isOriginal) !== "undefined") {
            obj.isOriginal = jsonObject.isOriginal;
        }
        if (typeof(jsonObject.bannerLargeImageUrl) !== "undefined") {
            obj.bannerLargeImageUrl = jsonObject.bannerLargeImageUrl;
        }
        if (typeof(jsonObject.bannerMediumImageUrl) !== "undefined") {
            obj.bannerMediumImageUrl = jsonObject.bannerMediumImageUrl;
        }
        if (typeof(jsonObject.bannerSmallImageUrl) !== "undefined") {
            obj.bannerSmallImageUrl = jsonObject.bannerSmallImageUrl;
        }
        if (typeof(jsonObject.commentIconKind) !== "undefined") {
            obj.commentIconKind = jsonObject.commentIconKind;
        }
        if (typeof(jsonObject.backgroundColor) !== "undefined") {
            obj.backgroundColor = jsonObject.backgroundColor;
        }
        if (typeof(jsonObject.visitedColor) !== "undefined") {
            obj.visitedColor = jsonObject.visitedColor;
        }
        if (typeof(jsonObject.textColor) !== "undefined") {
            obj.textColor = jsonObject.textColor;
        }
        if (typeof(jsonObject.buttonColor) !== "undefined") {
            obj.buttonColor = jsonObject.buttonColor;
        }
        if (typeof(jsonObject.description) !== "undefined") {
            obj.description = jsonObject.description;
        }
        if (typeof(jsonObject.workGenres) !== "undefined") {
            if (jsonObject.workGenres !== null) {
                obj.workGenres = [];
                for (let i = 0; i < jsonObject.workGenres.length; i++) {
                    const item = integer.createFromJson(jsonObject.workGenres[i]);
                    obj.workGenres.push(item);
                }
            } else {
                obj.workGenres = null;
            }
        }
        if (typeof(jsonObject.workStartedAt) !== "undefined") {
            obj.workStartedAt = jsonObject.workStartedAt;
        }
        if (typeof(jsonObject.workEndedAt) !== "undefined") {
            obj.workEndedAt = jsonObject.workEndedAt;
        }
        if (typeof(jsonObject.updateDayKind) !== "undefined") {
            obj.updateDayKind = jsonObject.updateDayKind;
        }
        if (typeof(jsonObject.updateIntervalName) !== "undefined") {
            obj.updateIntervalName = jsonObject.updateIntervalName;
        }
        if (typeof(jsonObject.newestStoryNumber) !== "undefined") {
            obj.newestStoryNumber = jsonObject.newestStoryNumber;
        }
        if (typeof(jsonObject.newestStoryTitle) !== "undefined") {
            obj.newestStoryTitle = jsonObject.newestStoryTitle;
        }
        if (typeof(jsonObject.isUpdated) !== "undefined") {
            obj.isUpdated = jsonObject.isUpdated;
        }
        if (typeof(jsonObject.hasEnded) !== "undefined") {
            obj.hasEnded = jsonObject.hasEnded;
        }
        if (typeof(jsonObject.shareUrl) !== "undefined") {
            obj.shareUrl = jsonObject.shareUrl;
        }
        if (typeof(jsonObject.personCategory) !== "undefined") {
            obj.personCategory = jsonObject.personCategory;
        }
        if (typeof(jsonObject.numberOfCheers) !== "undefined") {
            obj.numberOfCheers = jsonObject.numberOfCheers;
        }
        if (typeof(jsonObject.numberOfFavorites) !== "undefined") {
            obj.numberOfFavorites = jsonObject.numberOfFavorites;
        }
        if (typeof(jsonObject.isFavorite) !== "undefined") {
            obj.isFavorite = jsonObject.isFavorite;
        }
        if (typeof(jsonObject.isCheered) !== "undefined") {
            obj.isCheered = jsonObject.isCheered;
        }
        if (typeof(jsonObject.addCheerImageUrl) !== "undefined") {
            obj.addCheerImageUrl = jsonObject.addCheerImageUrl;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoWorkInfo()
request_data.workId = null;
request_data.workCode = null;
request_data.workName = null;
request_data.workNameKana = null;
request_data.authorName = null;
request_data.authorThumbnailUrl = null;
request_data.catchPhrase = null;
request_data.workKind = null;
request_data.isOriginal = null;
request_data.bannerLargeImageUrl = null;
request_data.bannerMediumImageUrl = null;
request_data.bannerSmallImageUrl = null;
request_data.commentIconKind = null;
request_data.backgroundColor = null;
request_data.visitedColor = null;
request_data.textColor = null;
request_data.buttonColor = null;
request_data.description = null;
request_data.workGenres = null;
request_data.workStartedAt = null;
request_data.workEndedAt = null;
request_data.updateDayKind = null;
request_data.updateIntervalName = null;
request_data.newestStoryNumber = null;
request_data.newestStoryTitle = null;
request_data.isUpdated = null;
request_data.hasEnded = null;
request_data.shareUrl = null;
request_data.personCategory = null;
request_data.numberOfCheers = null;
request_data.numberOfFavorites = null;
request_data.isFavorite = null;
request_data.isCheered = null;
request_data.addCheerImageUrl = null;
*/

/**
 * Information of the work.
 * @constructor
 */
export class KoreyomoWorkItem {
    constructor() {
        /**
         * @type { number } A unique identifier for work.
         */
        this.workId = null;
        /**
         * @type { string } A unique code for the publisher to identify the work.
         */
        this.workCode = null;
        /**
         * @type { string } The name of the work.
         */
        this.workName = null;
        /**
         * @type { string } Large banner Image URL.
         */
        this.bannerLargeImageUrl = null;
        /**
         * @type { string } Medium banner Image URL.
         */
        this.bannerMediumImageUrl = null;
        /**
         * @type { string } Small banner Image URL.
         */
        this.bannerSmallImageUrl = null;
        /**
         * @type { string } Monochrome banner Image URL.
         */
        this.bannerMonochromeImageUrl = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoWorkItem }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoWorkItem();
        if (typeof(jsonObject.workId) !== "undefined") {
            obj.workId = jsonObject.workId;
        }
        if (typeof(jsonObject.workCode) !== "undefined") {
            obj.workCode = jsonObject.workCode;
        }
        if (typeof(jsonObject.workName) !== "undefined") {
            obj.workName = jsonObject.workName;
        }
        if (typeof(jsonObject.bannerLargeImageUrl) !== "undefined") {
            obj.bannerLargeImageUrl = jsonObject.bannerLargeImageUrl;
        }
        if (typeof(jsonObject.bannerMediumImageUrl) !== "undefined") {
            obj.bannerMediumImageUrl = jsonObject.bannerMediumImageUrl;
        }
        if (typeof(jsonObject.bannerSmallImageUrl) !== "undefined") {
            obj.bannerSmallImageUrl = jsonObject.bannerSmallImageUrl;
        }
        if (typeof(jsonObject.bannerMonochromeImageUrl) !== "undefined") {
            obj.bannerMonochromeImageUrl = jsonObject.bannerMonochromeImageUrl;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoWorkItem()
request_data.workId = null;
request_data.workCode = null;
request_data.workName = null;
request_data.bannerLargeImageUrl = null;
request_data.bannerMediumImageUrl = null;
request_data.bannerSmallImageUrl = null;
request_data.bannerMonochromeImageUrl = null;
*/

/**
 * Recommendation results. To restore this result, you must hold the restoreToken and call the `/recommendWorksFromToken` API. 
 * @constructor
 */
export class KoreyomoWorkResult {
    constructor() {
        /**
         * @type { string } A unique identifier for this User. The userId that sent the feedback. If userId is sent in empty, it will be newly created       
         */
        this.userId = null;
        /**
         * @type { KoreyomoTopWorkItem } 
         */
        this.topWorkItem = null;
        /**
         * @type { KoreyomoMAIResult } 
         */
        this.maiResult = null;
        /**
         * @type { Array.<KoreyomoWorkItem> } 
         */
        this.rankingWorks = null;
        /**
         * @type { string } String for restoring recommended results.
         */
        this.restoreToken = null;
    }

    /**
     * Create model class from JSON.
     * @param { Object } jsonObject
     * @returns { KoreyomoWorkResult }
     */
    static createFromJson (jsonObject) {
        const obj = new KoreyomoWorkResult();
        if (typeof(jsonObject.userId) !== "undefined") {
            obj.userId = jsonObject.userId;
        }
        if (typeof(jsonObject.topWorkItem) !== "undefined") {
            obj.topWorkItem = jsonObject.topWorkItem;
        }
        if (typeof(jsonObject.maiResult) !== "undefined") {
            obj.maiResult = jsonObject.maiResult;
        }
        if (typeof(jsonObject.rankingWorks) !== "undefined") {
            if (jsonObject.rankingWorks !== null) {
                obj.rankingWorks = [];
                for (let i = 0; i < jsonObject.rankingWorks.length; i++) {
                    const item = KoreyomoWorkItem.createFromJson(jsonObject.rankingWorks[i]);
                    obj.rankingWorks.push(item);
                }
            } else {
                obj.rankingWorks = null;
            }
        }
        if (typeof(jsonObject.restoreToken) !== "undefined") {
            obj.restoreToken = jsonObject.restoreToken;
        }
        return obj;
  }
}

/*
var request_data = new KoreyomoWorkResult()
request_data.userId = null;
request_data.topWorkItem = null;
request_data.maiResult = null;
request_data.rankingWorks = null;
request_data.restoreToken = null;
*/


var mergeObject = function (obj1, obj2) {
    if (obj1 == null) {
        obj1 = {};
    }
    if (obj2 == null) {
        obj2 = {};
    }
    for (var attrname in obj2) {
        if (obj2.hasOwnProperty(attrname)) {
            obj1[attrname] = obj2[attrname];
        }
    }
    return obj1;
};



// WEBPACK FOOTER //
// ./src/api/apies6.js